// ----------------------------------------------------------------------

type Flattenable<T> = T & {
  [key: string]: T[] | unknown;
};

export function flattenArray<T>(list: T[], key = 'children'): T[] {
  if (!list || list.length === 0) {
    return [];
  }

  let children: T[] = [];

  for (const item of list) {
    const itemWithKey = item as Flattenable<T>;
    const childrenProperty = itemWithKey[key];
    if (Array.isArray(childrenProperty) && childrenProperty.length) {
      children = [...children, ...childrenProperty];
    }
  }

  return list.concat(children.length ? flattenArray(children, key) : children);
}
